"use strict";
import modalTemplate from "./casosPCD.informacion.html";
import modalController from "./casosPCD.informacion.controller.js";
import modalCorreccionTemplate from "./casosPCDCorregirCodigo.html";
import modalCorreccionController from "./casosPCDCorregirCodigo.controller.js";

class CasosPCD {
  constructor(NgTableParams, DataService, Message, Modal, $log, $scope) {
    "ngInject";
    //this.ValidationService = ValidationService;
    this.NgTableParams = NgTableParams;
    this.DataService = DataService;
    this.Message = Message;
    this.Modal = Modal;
    this.$log = $log;
    this.$scope = $scope;
    this.$scope.oneAtATime = true;
  }
  $onInit() {
    let contadorErrores = 0;
    this.reprocesarDeshabilitado = true;
    this.reprocesarIntermitenciasDeshabilitado = true;
    this.obtenerEstadoCorte();
    this.$log.log("Errores intermitencia: " + contadorErrores);
    this.paso_proceso = { nombre: 'CONTRASTACION_SEGIP' };
    this.pasosProceso = [
      { nombre: 'CONTRASTACION_SEGIP' },
      { nombre: 'SIN_REGISTRO_SIGEP' },
      {
        nombre: 'REGISTRO_SIGEP'
      },
      { nombre: 'ACTUALIZACION_SIGEP' },
    ];
  }

  obtenerEstadoCorte() {
    let paso8, paso12;
    const fechaInicioSoporte = 8;
    this.DataService.get(
      `centralizador/control_corte/detalle_control_corte?tipo=MENSUAL`
    )
      .then((respuesta) => {
        if (respuesta && respuesta.finalizado && respuesta.datos) {
          const pasosCorte = respuesta.datos.pasos ? respuesta.datos.pasos : respuesta.datos.detalleCorteAnterior.pasos
          const pasos = JSON.parse(pasosCorte);
          paso8 = pasos.find((p) => p.orden == 8);
          paso12 = pasos.find((p) => p.orden == 12);
          this.reprocesarDeshabilitado =
            paso8 &&
            (paso8.estado === "FINALIZADO" || paso8.estado === "EJECUCION");
          this.reprocesarIntermitenciasDeshabilitado =
            paso12 &&
            paso12.estado !== "HABILITADO" &&
            paso12.estado !== "PENDIENTE";
        } else if (new Date().getDate() >= fechaInicioSoporte) {
          this.reprocesarIntermitenciasDeshabilitado = false;
        } else {
          this.reprocesarDeshabilitado = false;
        }
      })
      .finally(() => {
        this.obtenerRegistros();
      });
  }

  obtenerRegistros() {
    const filtro_paso = (this.paso_proceso.nombre === '-- Seleccione un paso --' || this.paso_proceso === '') ? "" : this.paso_proceso.nombre;
    this.tableParams = new this.NgTableParams(
      {
        count: 10,
      },
      {
        getData: (params) => {
          let data = params.url();
          const { count, page } = data;
          const sort = this.getSorting(data);
          const query = {
            limit: count,
            page: page,
            nro_documento: this.nro_documento ? this.nro_documento : "",
            filtro_nombre: this.nombre_apellidos ? this.nombre_apellidos : "",
            filtro_paso: filtro_paso,
          };
          if (sort) {
            query.order = sort;
          }
          const resultado = this.DataService.list(
            "centralizador/soporte-casos-pcd",
            query
          ).then((response) => {
            if (response) {
              this.contadorErrores = response.datos.countErrorIntermitencia;
              if (this.contadorErrores === 0) { this.reprocesarIntermitenciasDeshabilitado = true; }
              params.total(response.datos.count);
              this.renderLabels({
                ini: (page - 1) * count + 1,
                end:
                  page * count < response.datos.count
                    ? page * count
                    : response.datos.count,
                total: response.datos.count,
              });
              return response.datos.rows;
            }
          });
          return resultado;
        },
      }
    );
  }

  getSorting(params) {
    for (let key in params) {
      if (key.indexOf("sorting") != -1) {
        return (
          (params[key] == "desc" ? "-" : "") +
          this.removeCorchete(key, "sorting")
        );
      }
    }
    return null;
  }

  renderLabels(params) {
    params;
  }

  validarSinCodigoBeneficiario(persona) {
    if (
      persona.observacion.includes(
        "Existe otro beneficiario con el mismo tipo de documento y número de documento"
      )
    )
      return true;
    return false;
  }

  modalValidaciones(persona) {
    this.Modal.show({
      template: modalTemplate,
      controller: modalController,
      data: persona,
      size: "lg",
    });
  }

  modalCorreccionCodigo(persona) {
    this.Modal.show({
      template: modalCorreccionTemplate,
      controller: modalCorreccionController,
      data: persona,
      size: "lg",
    });
  }

  reprocesar() {
    this.DataService.get(`centralizador/soporte/reprocesar`)
      .then((response) => {
        if (response && response.finalizado) {
          this.Message["success"]("Se ha reprocesado el registro");
        }
      })
      .then(() => {
        this.obtenerRegistros();
      });
  }

  reprocesarIndividual(id) {
    this.DataService.get(`centralizador/soporte/reprocesar/${id}`)
      .then((response) => {
        if (response && response.finalizado) {
          this.Message["success"]("Se ha reprocesado el registro");
        }
      })
      .then(() => {
        this.obtenerRegistros();
        this.loadingPersona = false;
      });
  }
}
export default CasosPCD;



// WEBPACK FOOTER //
// ./src/app/components/soporte/casosPCD/casosPCD.controller.js